export const ESTIMATES_PENDING_ROUTE = 'pending';
export const ESTIMATES_DONE_ROUTE = 'done';
